// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__GOs9H","title":"style_title__2lt-6","rows":"style_rows__v36z8"};